import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'

import { Auth0Plugin } from './auth';
import HighlightJs from './directives/highlight';

// Vue2Vis stuff (charting lib)
import { Network } from 'vue2vis';
import "vue2vis/dist/vue2vis.css";

import 'carbon-components/css/carbon-components.css';
import './styles/_carbon_override.scss';

// star rating
import StarRating from 'vue-star-rating'

import { library } from '@fortawesome/fontawesome-svg-core';
import { faLink, faUser, faPowerOff, faChevronDown, faChevronRight, faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';


import { domain, clientId } from '../auth_config.json';
Vue.config.productionTip = false;

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

// define some components
Vue.component('network', Network)
Vue.component('star-rating', StarRating);

Vue.directive("highlightjs", HighlightJs);

library.add(fas, fab, faLink, faUser, faPowerOff, faChevronDown, faChevronRight, faUserGraduate);
Vue.component("font-awesome-icon", FontAwesomeIcon);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
